import React, { useContext } from "react";
import { TextField } from "@mui/material";
import GroupBDRBiologists from "../FieldTags/GroupBDRBiologists";
import { UserContext } from "../../context/UserContext";
import xplanLabels from "../../util/XplanLabels";
import ROLES from "../../util/roles";
import HistoryLogElement from "./HistoryLogElement";
import { checkRole } from "../../util/FormUtils";

const newPlan = window.location.pathname === "/xplans/new";

const LabsComment = ({ labsComment, handleChange, xplans }) => {
    const { user } = useContext(UserContext);
    const canEdit = checkRole(user, [ROLES.BIOLOGIST, ROLES.APPROVER]);

    return (
        <div id="labsComment" className="planField">
            <GroupBDRBiologists />
            <TextField
                name="labsComment"
                label={xplanLabels.labsComment}
                InputLabelProps={{ shrink: true }}
                type="text"
                value={labsComment ? labsComment : ""}
                onChange={(e) => handleChange("labsComment", e.target.value)}
                multiline
                minRows={1}
                className="fullLength"
                disabled={!canEdit}
            />
            {!newPlan && <HistoryLogElement xplans={xplans} label={"labsComment"} />}
        </div>
    );
};

export default LabsComment;